<div class="dashboard-container">
  <portal-dashboard-folders-wrapper></portal-dashboard-folders-wrapper>
  <portal-drugs-table
    [medications]="nonTimedTriggerMedication$ | async"
    [text]="nonTimedTriggerTableText"
    [title]="nonTimedTriggerTableText.UpcomingDrugs"
    [emptyMessage]="nonTimedTriggerTableText.NoDrugs"
    [displayedColumns]="displayedColumnList"
    (gotoPatient)="gotoPatient($event)"
  ></portal-drugs-table>
</div>
